import React from 'react'
import clsx from 'clsx'

import styles from './style.module.scss'
import ensureBasePath from '../../lib/ensureBasePath'

export const ComingSoon = ({ title, imageSrc, link }) => {
  return (
    <a className={styles.coming_soon} style={{ backgroundImage: `url(${imageSrc})`, pointerEvents: link ? 'initial': 'none' }} href={link} >
      <h3 className={clsx('section-title', styles.section_title)}>{title}</h3>
    </a>
  )
}

ComingSoon.defaultProps = {
  title: 'Coming Soon',
  imageSrc: ensureBasePath('/images/coming-soon.jpg'),
  link: 'https://internship.traveloka.company/'
}

export default ComingSoon
